export default {
	authServer: 'https://aks-sandbox.sorted.com/auth',
	apiHost: 'https://api.sorted.com/pro-sandbox-ui/',
	gaPropertyId: 'UA-174047108-4',
	remotes: {
		shipments: 'https://sandbox-portal.sorted.com/shipments-mf'
	}
};
